import {Buffer} from 'buffer';
import { DateTime } from 'luxon';


export const getPayloadFromToken = token => {
    if (!token || token === '') return {};

    const decodedPayload = getDecodedPayload(token);
    //const encodedPayload = toString(token).split('.')[1];
    //console.log('Encoded Payload: ', decodedPayload);
    //const parsed = JSON.parse(Buffer.from(decodedPayload, 'base64'));
    //console.log('Parsed Value: ',parsed)
  
    for (const key in decodedPayload) {
        try {
            let val = decodedPayload[key];
            decodedPayload[key] = JSON.parse(val);
            if (key === "Roles") {
                let rolesArray = decodedPayload[key];
                decodedPayload["roles"] = rolesArray.map(x=>x.RoleID);
            }
        } catch (e) {
            continue;
        }
        
    }
    //console.log('my parsed user info:', parsed);
    //decodedPayload['token'] = token;
    //console.log('my parsed user info:', decodedPayload);
    return decodedPayload;
};

export const getDecodedPayload= token =>{
     try {
    // Split the token into its parts
    const payloadBase64Url = token.split('.')[1];
    
    // Decode the Base64Url string
    const payloadBase64 = payloadBase64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payloadString = atob(payloadBase64);
    
    return payloadString; // Returns the payload as a string
  } catch (error) {
    console.error('Invalid JWT token:', error);
    return null;
  }
}


export const uuidv4 = () => {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}


/**
 * Format a number as USD currency, e.g. 1150 -> "$1,150.00".
 * Safe for null/undefined/NaN inputs (returns "$0.00").
 */
export const formatMoney = (value) => {
  const num = Number(value);
  const safe = Number.isFinite(num) ? num : 0;
  return `$${safe.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const convertDateFull = (timeObj, includeTime) => {
  let format = null;
  if(!includeTime)
  {
    format = {...DateTime.DATE_FULL };
  }
  else{
    format = {...DateTime.DATETIME_FULL};
  }
  return DateTime.fromISO(timeObj, { zone: "utc" }).toLocaleString(format);
}